import React from 'react'

export default () => (
  <div>
    <h1>Sign in</h1>
  </div>
)



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/SignIn.js